import { styled, type StyledProps } from '@compiled/react';

// eslint-disable-next-line import/order
import { token } from '@atlaskit/tokens';
// eslint-disable-next-line import/order
import type { ComponentType, ClassAttributes, AnchorHTMLAttributes } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const AIWhoAnswerFooterResult: ComponentType<
	ClassAttributes<HTMLAnchorElement> & AnchorHTMLAttributes<HTMLAnchorElement> & StyledProps
	// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
> = styled.a({
	display: 'flex',
	alignItems: 'center',
	paddingTop: token('space.150'),
	paddingRight: token('space.150'),
	paddingBottom: token('space.150'),
	paddingLeft: token('space.150'),
	border: `solid ${token('color.border')} ${token('border.width')}`,
	borderRadius: token('radius.medium'),
	boxSizing: 'border-box',
	backgroundColor: token('color.background.input'),
	'&:hover': {
		textDecoration: 'none',
		boxShadow: token('elevation.shadow.overlay'),
	},
});
